module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAV4AAAACCAYAAAAQELQiAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAArSURBVEiJY3zuaP2fYRQMWsCyasNAO2EUjIJRQGXANNAOGAWjYBSMgpEGAOxSA8S3Is/YAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/images/investCenter/line_01.png
// module id = AnVs
// module chunks = 0